import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import './i18n';

import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Layout from './components/Layout/layout';
import ErrorPage from './pages/error-page';

import { SubdomainProvider } from './contexts/subdomain';
import PaymentLinkPage from './pages/payment-link/payment-link-page';
import ServicePage from './pages/services/services-page';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout><ServicePage /></Layout>,
    errorElement: <ErrorPage />,
  },
  {
    path: '/payment-link/:id',
    element: <Layout><PaymentLinkPage /></Layout>,
    errorElement: <ErrorPage />,
  },
  {
    path: '/:id',
    element: <Layout><ServicePage /></Layout>,
    errorElement: <ErrorPage />,
  },
  {
    path: '*',
    element: <Layout><ErrorPage /></Layout>,
  }
]);

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <SubdomainProvider>
      <RouterProvider router={router} />
      <ToastContainer />
    </SubdomainProvider>
  </React.StrictMode>
);

reportWebVitals();